import { render, staticRenderFns } from "./ngo-registration-steps.vue?vue&type=template&id=f8e0a582&scoped=true&"
import script from "./ngo-registration-steps.vue?vue&type=script&lang=js&"
export * from "./ngo-registration-steps.vue?vue&type=script&lang=js&"
import style0 from "./ngo-registration-steps.vue?vue&type=style&index=0&id=f8e0a582&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8e0a582",
  null
  
)

export default component.exports